import React from 'react';
import Error from 'components/Error';

interface Props {
  restartChat: () => void;
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {
  state = {
    hasError: false,
  };

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return <Error restartChat={this.props.restartChat} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
